import './style.css';
import { Circle as CircleStyle, Fill, Stroke, Icon, Style } from 'ol/style.js';
import Feature from 'ol/Feature.js';
import { Map, View } from 'ol';
import { Point, Circle, Polygon } from "ol/geom"
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer.js';
import { OSM, Vector as VectorSource } from 'ol/source.js';
import { transform } from "ol/proj"
import { Draw, Modify, Snap, Select, Translate, defaults as defaultInteractions } from 'ol/interaction.js';
import axios from "axios"
import parkingFreeImg from './images/parking-free.png'
import parkingHandicappedFreeImg from './images/parking-handicapped-free.png'
import parkingOccupiedImg from './images/parking-occupied.png'
import parkingHandicappedOccupiedImg from './images/parking-handicapped-occupied.png'
import bicycleParkingImage0 from './images/bicycle0.png'
import bicycleParkingImage1 from './images/bicycle1.png'
import bicycleParkingImage2 from './images/bicycle2.png'
import bicycleParkingImage3 from './images/bicycle3.png'
import bicycleParkingImage4 from './images/bicycle4.png'
import bicycleParkingImage5 from './images/bicycle5.png'
import bicycleParkingImage6 from './images/bicycle6.png'
import bicycleParkingImage7 from './images/bicycle7.png'
import bicycleParkingImage8 from './images/bicycle8.png'
import bicycleParkingImage9 from './images/bicycle9.png'
import bicycleParkingImage10 from './images/bicycle10.png'
import bicycleParkingImage11 from './images/bicycle11.png'
import bicycleParkingImage12 from './images/bicycle12.png'
import bicycleParkingImage13 from './images/bicycle13.png'
import bicycleParkingImage14 from './images/bicycle14.png'
import bicycleParkingImage15 from './images/bicycle15.png'
import bicycleParkingImage16 from './images/bicycle16.png'
import bicycleParkingImage9999 from './images/bicycle9999.png'
import mobileStationImage from './images/mobile-station.png'

const bicycleParkingImages = [
  bicycleParkingImage0,
  bicycleParkingImage1,
  bicycleParkingImage2,
  bicycleParkingImage3,
  bicycleParkingImage4,
  bicycleParkingImage5,
  bicycleParkingImage6,
  bicycleParkingImage7,
  bicycleParkingImage8,
  bicycleParkingImage9,
  bicycleParkingImage10,
  bicycleParkingImage11,
  bicycleParkingImage12,
  bicycleParkingImage13,
  bicycleParkingImage14,
  bicycleParkingImage15,
  bicycleParkingImage16,
];

const mapProj = 'EPSG:3857';
const wgs84Proj = 'EPSG:4326';

// Production
const URL = "";
// Development
//const URL = "http://localhost/";

const urlParams = new URLSearchParams(window.location.search);
const editorMode = urlParams.get('editorMode');

document.getElementById("copyright").innerHTML = "ifak - Institut für Automation und Kommunikation e.V. © " + (new Date()).getFullYear() + ".<br/>All rights reserved.";

const red = new Style({
  fill: new Fill({
    color: 'rgba(255, 0, 0, 0.9)',
  }),
  stroke: new Stroke({
    color: '#800000',
    width: 2,
  }),
  image: new CircleStyle({
    radius: 7,
    fill: new Fill({
      color: '#ffcc33',
    }),
  }),
});

let bicycleParkingFeature;

let source = new VectorSource();

const select = new Select();

const translate = new Translate({
  features: select.getFeatures(),
});

const map = new Map({
  target: 'map',
  layers: [
    new TileLayer({
      source: new OSM()
    }),
    new VectorLayer({
      source: source,
      style: red
    }),
  ],
  view: new View({
    center: new Point([11.657704, 52.142593]).transform(wgs84Proj, mapProj).getCoordinates(),
    zoom: 20
  })
});

let draw = new Draw({
  source: source,
  type: "Polygon",
});
draw.on("drawend", function (e) {
  //updateParkinglot(e.feature);
});
editorMode === 'create' && map.addInteraction(draw);
let snap = new Snap({ source: source });
(editorMode === 'create' || editorMode === 'modify') && map.addInteraction(snap);

const modify = new Modify({ source: source });
(editorMode === 'create' || editorMode === 'modify') && map.addInteraction(modify);
modify.on("modifyend", function (e) {
  let features = e.features.getArray();
  //updateParkinglot(features[0]);
});

translate.on("translateend", function (e) {
  let features = e.features.getArray();
  updateParkinglot(features[0]);
});

(editorMode === 'create' || editorMode === 'modify') && map.addInteraction(select);
editorMode === 'modify' && map.addInteraction(translate);

const mobileStationStyle = new Style({
  image: new Icon({
    anchor: [0.5, 0.5],
    anchorXUnits: 'fraction',
    anchorYUnits: 'fraction',
    scale: 1.0,
    src: mobileStationImage
  }),
  zIndex: 200,
});
const mobileStationFeature = new Feature({
  geometry: new Point([11.551673815911668, 51.518243805327245]).transform(wgs84Proj, mapProj)
});
mobileStationFeature.setStyle(mobileStationStyle);
source.addFeature(mobileStationFeature);


let selected = null;
map.on('pointermove', function (e) {
  if (selected !== null) {
    selected = null;
  }

  map.forEachFeatureAtPixel(e.pixel, function (f) {
    selected = f;
    return true;
  });
});

readParkinglots();
readValues();

var timer = window.setInterval(readValues, 5000);

function readValues() {
  axios
    .get(URL + "get_values")
    .then(function (jsondata) {
      let lastTimestamp = undefined;
      let freeWithoutRestrict = 0;
      let freeHandicapped = 0;
      source.getFeatures().forEach((feature) => {
        jsondata.data.forEach((sensor) => {
          if (sensor.id == feature.get("parkinglotId")) {
            if (feature.get("state") != sensor.state) {
              console.info("Update sensor " + sensor.id);
              feature.setStyle(sensor.state == 1 ? feature.get("occupiedStyle") : feature.get("freeStyle"));
              feature.set("state", sensor.state);
            }
            feature.set("since", sensor.since);
            lastTimestamp = sensor.since;
            if (sensor.state == 0 && feature.get("handicapped") != 1)
              freeWithoutRestrict = freeWithoutRestrict + 1;
            if (sensor.state == 0 && feature.get("handicapped") == 1)
              freeHandicapped = freeHandicapped + 1;
          }
        });
      });
      lastTimestamp && setLastTimestamp(lastTimestamp);
      lastTimestamp && setParkInfos(freeWithoutRestrict, freeWithoutRestrict, freeHandicapped);
    })
    .catch(function (error) {
      console.warn(error);
      console.log(jsondata.data);
    });
  readBikeInfos();
  readRentalBikeInfos();
}

function readParkinglots() {
  axios
    .get(URL + "get_parkinglots")
    .then(function (jsondata) {
      let lastTimestamp = undefined;
      let freeWithoutRestrict = 0;
      let freeHandicapped = 0;
      jsondata.data.forEach(parkinglot => {
        let feature = new Feature({
          geometry: new Point([parkinglot.lon, parkinglot.lat]),
        });
        if (parkinglot.handicapped == 1) {
          let freeStyle = new Style({
            image: new Icon({
              anchor: [0.5, 0.5],
              anchorXUnits: 'fraction',
              anchorYUnits: 'fraction',
              scale: 0.8,
              rotation: parkinglot.rotation,
              src: parkingHandicappedFreeImg,
            }),
          });
          let occupiedStyle = new Style({
            image: new Icon({
              anchor: [0.5, 0.5],
              anchorXUnits: 'fraction',
              anchorYUnits: 'fraction',
              scale: 0.8,
              rotation: parkinglot.rotation,
              src: parkingHandicappedOccupiedImg,
            }),
          });
          feature.set("freeStyle", function (feature, resolution) {
            let zoom = map.getView().getZoomForResolution(resolution);
            return zoom > 18 ? freeStyle : null;
          });
          feature.set("occupiedStyle", function (feature, resolution) {
            let zoom = map.getView().getZoomForResolution(resolution);
            return zoom > 18 ? occupiedStyle : null;
          });
        }
        else {
          let freeStyle = new Style({
            image: new Icon({
              anchor: [0.5, 0.5],
              anchorXUnits: 'fraction',
              anchorYUnits: 'fraction',
              scale: 0.7,
              rotation: parkinglot.rotation,
              src: parkingFreeImg,
            }),
          });
          let occupiedStyle = new Style({
            image: new Icon({
              anchor: [0.5, 0.5],
              anchorXUnits: 'fraction',
              anchorYUnits: 'fraction',
              scale: 0.7,
              rotation: parkinglot.rotation,
              src: parkingOccupiedImg,
            }),
          });
          feature.set("freeStyle", function (feature, resolution) {
            let zoom = map.getView().getZoomForResolution(resolution);
            return zoom > 18 ? freeStyle : null;
          });
          feature.set("occupiedStyle", function (feature, resolution) {
            let zoom = map.getView().getZoomForResolution(resolution);
            return zoom > 18 ? occupiedStyle : null;
          });
        }
        feature.setStyle(parkinglot.state == 1 ? feature.get("occupiedStyle") : feature.get("freeStyle"));
        feature.set("parkinglotId", parkinglot.id);
        feature.set("handicapped", parkinglot.handicapped);
        feature.set("state", parkinglot.state);
        source.addFeature(feature);
        lastTimestamp = parkinglot.since;
        if (parkinglot.state == 0 && parkinglot.handicapped != 1)
          freeWithoutRestrict = freeWithoutRestrict + 1;
        if (parkinglot.state == 0 && parkinglot.handicapped == 1)
          freeHandicapped = freeHandicapped + 1;
      });
      lastTimestamp && setLastTimestamp(lastTimestamp);
      lastTimestamp && setParkInfos(freeWithoutRestrict, freeWithoutRestrict, freeHandicapped);
      let extent = source.getExtent();
      if (extent[0] == Number.POSITIVE_INFINITY || extent[0] == Number.NEGATIVE_INFINITY ||
        extent[1] == Number.POSITIVE_INFINITY || extent[1] == Number.NEGATIVE_INFINITY ||
        extent[2] == Number.POSITIVE_INFINITY || extent[2] == Number.NEGATIVE_INFINITY ||
        extent[3] == Number.POSITIVE_INFINITY || extent[3] == Number.NEGATIVE_INFINITY)
        return;
      map.getView().fit(extent, {
        size: map.getSize(),
        duration: 500,
        maxZoom: 20
      });
    })
    .catch(function (error) {
      console.warn(error);
    })
}

function readBikeInfos() {
  axios
    .get(URL + "get_bike_infos")
    .then(function (jsondata) {
      jsondata.data.forEach(parkinglot => {
        if (!bicycleParkingFeature) {
          bicycleParkingFeature = new Feature({
            geometry: new Point([parkinglot.lon, parkinglot.lat]),
          });
          source.addFeature(bicycleParkingFeature);
        }
        const style = new Style({
          image: new Icon({
            anchor: [0.5, 0.42],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            scale: 0.6,
            rotation: 0.6,
            src: parkinglot.free >= 0 && parkinglot.free <= 16 && parkinglot.error == 0 ? bicycleParkingImages[parkinglot.free] : bicycleParkingImage9999,
          }),
          zIndex: 100,
        });

        bicycleParkingFeature.setStyle(function (feature, resolution) {
          let zoom = map.getView().getZoomForResolution(resolution);
          return zoom > 18 ? style : null;
      });
        bicycleParkingFeature.set("parkinglotId", 'B' + parkinglot.id);
        setBikeInfos(parkinglot.free, parkinglot.capacity, parkinglot.error);
      });
    })
    .catch(function (error) {
      console.warn(error);
    })
}

function readRentalBikeInfos() {
  axios
    .get(URL + "get_rental_bike_infos")
    .then(function (jsondata) {
      console.info(jsondata)
      jsondata.data.forEach(parkinglot => {
        setRentalBikeInfos(parkinglot.available, parkinglot.capacity, parkinglot.error);
      });
    })
    .catch(function (error) {
      console.warn(error);
    })
}

function updateParkinglot(feature) {
  let coordinates = feature.getGeometry().clone().transform(mapProj, wgs84Proj).getCoordinates();
  let id = feature.get("parkinglotId");
  axios
    .post(URL + "update_parkinglot", { id: id, coordinates: coordinates })
    .then(function (response) {
      console.log("Response: ")
      console.log(response)
    })
    .catch(function (error) {
      console.log("Error: ")
      console.error(error)
    })
}

function showInfo() {
  document.getElementById("info").classList.toggle('close');
  document.getElementById("menu").style.visibility = "hidden";
}

function closeInfo() {
  document.getElementById("info").classList.toggle('close');
  document.getElementById("menu").style.visibility = "visible";
}

function setLastTimestamp(timestamp) {
  document.getElementById("timestamp").innerHTML = timestamp;
}

function setParkInfos(sensor, withoutRestrict, disable) {
  document.getElementById("parking_without_restrict").innerHTML = 'Pkw ohne Einschränkung: <font class="parking-free">' + withoutRestrict + '</font> von <font class="parking-capacity">29</font>';
  document.getElementById("parking_disable").innerHTML = 'Behindertenparkplätze: <font class="parking-free">' + disable + '</font> von <font class="parking-capacity">2</font>';
}

function setBikeInfos(free, capacity, error) {
  if (free == 9999 || error != 0)
    document.getElementById("parking_bicycle").innerHTML = 'Fahrradstellplätze: <font class="parking-capacity-error" title="Daten aktuell nicht verfügbar">9999</font><img id="bicyle-info-icon" title="Daten aktuell nicht verfügbar" src="info.png"/>';
  else
    document.getElementById("parking_bicycle").innerHTML = 'Fahrradstellplätze: <font class="parking-free">' + free + '</font> von <font class="parking-capacity">' + capacity + '</font>';

}

function setRentalBikeInfos(available, capacity, error) {
  if (available == 9999 || error != 0)
    document.getElementById("rental_bike_infos").innerHTML = 'Verfügbar: <font class="parking-capacity-error" title="Daten aktuell nicht verfügbar">9999</font><img id="bicyle-info-icon" title="Daten aktuell nicht verfügbar" src="info.png"/>';
  else
    document.getElementById("rental_bike_infos").innerHTML = 'Verfügbar: <font class="parking-free">' + available + '</font> von <font class="parking-capacity">' + capacity + '</font>';

}

window.showInfo = showInfo;
window.closeInfo = closeInfo;
window.setLastTimestamp = setLastTimestamp;
window.setParkInfos = setParkInfos;
window.setBikeInfos = setBikeInfos;
window.setRentalBikeInfos = setRentalBikeInfos;
